module.exports = __webpack_public_path__ + "img/pn.48bd62e4.svg";